'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionDocument', ['$scope', '$stateParams', '$state', 'Documents', 'Upload', 'FileTypes', '$rootScope',
        function ($scope, $stateParams, $state, Documents, Upload, FileTypes, $rootScope) {
        $scope.resetInspection();
        $scope.inspection_document = $stateParams.inspection_document;
        $scope.inspectionDocumentID = $stateParams.inspectionDocumentID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        $scope.file_reset = false;
        $scope.max_file_size = ($rootScope.enterprise.max_file_size !== null) ? $rootScope.enterprise.max_file_size : 23000; // default max iis size
        $scope.messages = [];

        if ($stateParams.inspectionDocumentID != null) {
            Documents.getByID($stateParams.inspectionDocumentID).then(function (document) {
                $scope.inspection_document = document;
                $scope.loading = false;
            });
        }
        else {
            $scope.inspection_document = {};
            $scope.loading = false;
            FileTypes.getByEnterprise().then(function (types) {
                if (types != null && types.length > 0) {
                    $scope.extensions = types.toString();
                } else {
                    $scope.extensions = '*';
                }
            });
        }

        $scope.fileChange = function (document) {
            $scope.messages = [];
            if (!$scope.working) {
                $scope.uploading = false;
            }
            if ((Object.keys($scope.inspection_document).length === 0 || document === undefined) && !$scope.file_reset) { $scope.messages.push("File not accepted, please check the file extension and size."); }
            $scope.file_reset = false;
        }

        $scope.fileUpdated = function (file) {
            if (file != null) {
                const file_extension = file.name.split('.').pop();
                if ($scope.extensions.includes(file_extension)) {
                    $scope.working = true;
                    Upload.base64DataUrl(file).then(function (content) {
                        $scope.inspection_document.file_content = content;
                        $scope.inspection_document.file_name = file.name;
                        $scope.inspection_document.file_updated = true;
                        $scope.working = false;
                        $scope.uploading = false;
                        $scope.messages = [];
                    });
                } else {
                    $scope.messages.push("Document file extension not accepted.");
                    $scope.uploading = false;
                }
            }
            else {
                $scope.uploading = false;
                $scope.message = [];
                $scope.file_reset = true;
            }
        }

        $scope.filePicked = function () {
            $scope.uploading = true;
        }

        $scope.save = function () {
            $scope.saving = true;

            if ($scope.inspectionDocumentID == null) {
                // ensure file abides by file extension & size rules (*1000 for KB)
                const extension = $scope.inspection_document.file.name.split('.').pop();
                if ($scope.inspection_document.file.size <= ($scope.max_file_size * 1000) && $scope.extensions.toLowerCase().includes(extension.toLowerCase())) {
                    Documents.upload($scope.inspection_document, $scope.inspectionID).then(function (document) {
                        updateArray($scope.inspection.documents, document);
                        updateArray($scope.masterInspection.documents, document);
                        $state.go('internal.inspecting.inspection.documents', { id: $scope.inspectionID });
                        $scope.saving = false;
                    });
                }
                else
                {
                    if ($scope.inspection_document.file.size > ($scope.max_file_size * 1000)) { $scope.messages.push("Document not saved: file size too large.") }
                    if (!$scope.extensions.toLowerCase().includes(extension.toLowerCase())) { $scope.messages.push("Document not saved: file extension not accepted.") }
                    $scope.saving = false;
                }
            }
            else {
                Documents.save($scope.inspection_document, true, $scope.inspectionID).then(function (document) {
                    updateArray($scope.inspection.documents, document);
                    updateArray($scope.masterInspection.documents, document);
                    $state.go('internal.inspecting.inspection.documents', { id: $scope.inspectionID });
                    $scope.saving = false;
                });
            }
        }

        $scope.delete = function () {
            $scope.deleting = true;

            if ($stateParams.inspectionDocumentID) {
                Documents.delete($stateParams.inspectionDocumentID).then(function () {
                    updateArray($scope.inspection.documents, $scope.inspection_document, true);
                    updateArray($scope.masterInspection.documents, $scope.inspection_document, true);
                    $scope.deleting = false;
                    $state.go('internal.inspecting.inspection.documents', { id: $scope.inspectionID });
                });
            }
        }
    }])
;